import { Flex } from '@/components/Flex'
import { Typography } from '@/components/Typography'

interface TagRenderProps {
  label: string
  count: number
}

export function TagRender({ label, count }: TagRenderProps) {
  return (
    <Flex gap={4} style={{ paddingLeft: '0.5rem' }}>
      <Typography.Text>{label}</Typography.Text>
      <Typography.Text type="secondary">({count})</Typography.Text>
    </Flex>
  )
}
